import { render, staticRenderFns } from "./CandidateAcceptModalBulk.vue?vue&type=template&id=cb2ea82e&lang=pug"
import script from "./CandidateAcceptModalBulk.vue?vue&type=script&lang=js"
export * from "./CandidateAcceptModalBulk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports